
// 资源库分享弹框
Vue.component("video_question_modal", {
  props: {
    marks: {
      type: Array,
      default: []
    },
    params: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      player: null,
      visible: false,
      currentPoint: 0,
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      state: 1,//1-待提交，2-待下一题，3-待点击完成
      questionList: [],
      questionIndex: -1,
      currentQuestion: {},
      questionAnswer: '',
      showAnalysis: false
    };
  },
  watch: {
    showAnalysis(newVal, oldVal) {
      if (newVal) {
        this.$nextTick(() => {
          setTimeout(() => {
            window.MathJax.typeset()
          }, 100);
        });
      }
    },
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          setTimeout(() => {
            window.MathJax.typeset()
          }, 100);
        });
      }
    }
  },
  methods: {
    onProgressChange(player) {
      this.player = player
      let cur = parseInt(player.currentTime || 0) * 10000000
      if (this.currentPoint != cur) this.currentPoint = 0 //防止关闭弹框后seek回来不弹框
      if (this.marks.includes(cur)) {
        if (this.currentPoint != cur) {
          this.currentPoint = cur
          this.page = 1
          this.questionIndex = -1
          this.getQuestion(cur, true)
        }
      }
    },
    getQuestion(pointIn, isFirst) {
      const that = this
      that.loading = true
      API.reqVideoQuestionList({ ...this.params, pointIn, pageIndex: this.page, pageSize: this.size, isAnswer: false }).then(res => {
        if (!res.success) return Promise.reject()
        if (isFirst) {
          that.total = res.data.recordTotal
        }
        let ids = res.data.data
        if (!ids.length) return
        that.player.pause()
        that.visible = true
        API.reqQuestionListById(ids.map(el => el.questionId)).then(res => {
          if (res.status != 200) return Promise.reject()
          ids.map((el, i) => {
            let obj = (res.data || []).find(e => e.id == el.questionId)
            that.questionList.push({ ...el, ...obj })
          })
          that.handleNext()
        })
      }).finally(() => {
        that.loading = false
      })
    },
    //点击提交
    handleConfirm() {
      //调接口保存提交
      let { resourceId, versionName } = this.params
      let questionUniqueId = this.currentQuestion.uniqueId
      let pointIn = this.currentPoint
      let questionAnswer = this.questionAnswer
      let isAnswerCorrect = false
      if (this.currentQuestion.questions_type == 0 || this.currentQuestion.questions_type == 4) {
        //单选、判断，正确
        isAnswerCorrect = this.currentQuestion.questions_answers.includes(questionAnswer)
      } else if (this.currentQuestion.questions_type == 1) {
        //多选，正确
        questionAnswer = JSON.stringify(this.questionAnswer.sort())
        isAnswerCorrect = (questionAnswer.toLowerCase() == JSON.stringify(this.currentQuestion.questions_answers.sort()).toLowerCase())
      } else if (this.currentQuestion.questions_type == 2) {
        //填空，正确
        questionAnswer = JSON.stringify(this.questionAnswer || '')
        isAnswerCorrect = (questionAnswer.toLowerCase() == JSON.stringify(this.currentQuestion.questions_answers).toLowerCase())
      }

      this.isAnswerCorrect = isAnswerCorrect

      this.loading = true
      API.reqSubmitQuestion({ resourceId, versionName, questionUniqueId, pointIn, isAnswerCorrect, questionAnswer }).then(res => {
        if (!res.success) return this.$message.error(this.$t('提交出错！'))
        this.state = 2
        //如果题库已刷完
        if (this.questionIndex >= (this.total - 1)) {
          this.state = 3
        }
      }).finally(() => {
        this.loading = false
      })
    },
    //点击下一题
    handleNext() {
      if (this.loading) return
      this.questionAnswer = ''
      this.showAnalysis = false
      if (this.questionList[this.questionIndex + 1]) {
        //列表还有题，直接跳转下一题
        this.state = 1
        this.questionIndex++
        this.currentQuestion = {
          ...this.questionList[this.questionIndex],
          // questions_answers: this.questionList[this.questionIndex].questions_answers.map(item => item.replace(/\\/g, '').trim())
          // questions_answers: this.questionList[this.questionIndex].questions_answers.map(item => item.replace(/<[^>]*>/g, '').trim())
        }
        if (this.currentQuestion.questions_type == 1 || this.currentQuestion.questions_type == 2) {
          //多选题需要初始化answer字段为数组
          this.questionAnswer = []
        } else {
          this.questionAnswer = ''
        }
      } else if (this.questionIndex < this.total - 1) {
        //当前列表没有题了，需要翻页
        let cur = parseInt(this.player.currentTime || 0) * 10000000
        this.getQuestion(cur)
      } else {
        //列表没有题了，显示完成按钮
        this.state = 3
      }
    },
    //关闭弹窗
    handleClose() {
      this.questionList = []
      this.visible = false
      // this.player.play()
    },
    //获取ABCD
    getOptionTag(index) {
      return String.fromCharCode(65 + index)
    },
  },
  template: `
      <el-dialog :visible.sync="visible" title="" width="490px" @close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="video_question_modal">
          <div slot="title">
            <span>{{$t('请完成题目')}}<span class="sort">{{questionIndex + 1 + '/' + total}}</span></span>
            <a @click="handleClose">{{$t('关闭，再去学学')}}</a>
          </div>
          <div v-loading="loading">
            <div v-if="currentQuestion.questions_type == 0" class="question_content type_0">
              <p class="title"><span class="type">({{$t('单选题')}})</span> <span v-html="currentQuestion.questions_content"></span></p>
              <el-radio v-model="questionAnswer" :label="getOptionTag(i)" v-for="q,i in currentQuestion.questions_options" :disabled="state != 1">
                <span>{{getOptionTag(i)}}&nbsp;&nbsp;</span><span v-html="q.content"></span>
                <template v-if="getOptionTag(i) == questionAnswer && state != 1">
                  <span class="tag current" v-if="isAnswerCorrect"><i></i> {{$t('正确')}}</span>
                  <span class="tag error" v-else><i></i> {{$t('错误')}}</span>
                </template>
              </el-radio>
            </div>
            
            <div v-if="currentQuestion.questions_type == 1" class="question_content type_1">
              <p class="title"><span class="type">({{$t('多选题')}})</span> <span v-html="currentQuestion.questions_content"></span></p>
              <el-checkbox-group v-model="questionAnswer">
                <el-checkbox :label="getOptionTag(i)" v-for="q,i in currentQuestion.questions_options" :disabled="state != 1">
                  <span>{{getOptionTag(i)}}&nbsp;&nbsp;</span><span v-html="q.content"></span>
                  <template v-if="currentQuestion.questions_answers.includes(getOptionTag(i)) && state != 1">
                    <span class="tag current" v-if="questionAnswer.includes(getOptionTag(i))"><i></i> {{$t('正确')}}</span>
                    <span class="tag error" v-else><i></i> {{$t('错误')}}</span>
                  </template>
                </el-checkbox>
              </el-checkbox-group>
            </div>
            
            <div v-if="currentQuestion.questions_type == 2" class="question_content type_2">
              <p class="title"><span class="type">({{$t('填空题')}})</span> <span v-html="currentQuestion.questions_content"></span></p>
              <div>
                <div v-for="q,i in currentQuestion.questions_options" class="type_2_content">
                  <span>{{$t('第空', {num: i+1})}}：</span>
                  <el-input size="small" v-model="questionAnswer[i]" :disabled="state != 1"></el-input>
                  <template v-if="i < currentQuestion.questions_answers.length && state != 1">
                    <span  :test="currentQuestion.questions_answers[i]" :test1="questionAnswer[i]"></span>
                    <span class="tag current" v-if="currentQuestion.questions_answers[i].toLowerCase() == (questionAnswer[i] || '').toLowerCase()"><i></i> {{$t('正确')}}</span>
                    <span class="tag error" v-else><i></i> {{$t('错误')}}</span>
                  </template>
                </div>
              </div>
            </div>
            
            <div v-if="currentQuestion.questions_type == 4" class="question_content type_4">
              <p class="title"><span class="type">({{$t('判断题')}})</span> <span v-html="currentQuestion.questions_content"></span></p>
              <el-radio v-model="questionAnswer" :label="getOptionTag(i)" v-for="q,i in currentQuestion.questions_options" :disabled="state != 1">
                <span>{{getOptionTag(i)}}&nbsp;&nbsp;</span><span v-html="q.content"></span>
                <template v-if="questionAnswer.includes(getOptionTag(i))  && state != 1">
                  <span class="tag current" v-if="currentQuestion.questions_answers.includes(getOptionTag(i))"><i></i> {{$t('正确')}}</span>
                  <span class="tag error" v-else><i></i> {{$t('错误')}}</span>
                </template>
              </el-radio>
            </div>

            <div class="analysis" v-if="state != 1">
              <a  v-if="showAnalysis" @click="showAnalysis = false">{{$t('收起解析')}}<i class="el-icon-arrow-up"></i></a>
              <a v-else @click="showAnalysis = true">{{$t('查看解析')}}<i class="el-icon-arrow-down"></i></a>
              <template v-if="showAnalysis">
                <p>{{$t('答案')}}：<span v-html="(currentQuestion.questions_answers || []).join(',')"></span></p>
                <p v-if="currentQuestion.questions_analysis" v-html="currentQuestion.questions_analysis"></p>
              </template>
            </div>
          </div>
          <div slot="footer">
              <el-button type="primary" v-if="state == 1" @click="handleConfirm">{{$t('提交')}}</el-button>
              <el-button type="primary" v-if="state == 2" @click="handleNext">{{$t('下一题')}}</el-button>
              <el-button type="primary" v-if="state == 3" @click="handleClose">{{$t('完成，继续学习')}}</el-button>
          </div>
      </el-dialog>
  `,
});